// components/common/MobileDrawer.tsx
import React from 'react';
import { X } from '@phosphor-icons/react';
import { MobileDrawerProps } from 'types/drawer';

const MobileDrawer: React.FC<MobileDrawerProps> = ({ isVisible, onClose, onCloseOverlay, children, width = 500 }) => {
  return (
    <div className={`fixed inset-0 z-50 flex justify-start ${isVisible ? 'visible' : 'invisible'}`}>
      {/* Overlay */}
      <div
        className={`absolute inset-0 bg-[var(--textBlack)] transition-opacity duration-300 ${
          isVisible ? 'opacity-50' : 'opacity-0'
        }`}
        onClick={onCloseOverlay}
      ></div>

      {/* Drawer */}
      <div
        className={`relative bg-[var(--textWhite)] min-w-[${width}px] max-w-[${width}px] flex flex-col h-full transform transition-transform duration-300 ease-out shadow-xl overflow-auto ${
          isVisible ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        {/* Close Button */}
        <div className='absolute top-0 right-0 p-4 z-10'>
          <button
            className='text-[var(--textGray500)] hover:text-[var(--textGray700)] focus:outline-none'
            onClick={onClose}
          >
            <X size={24} />
          </button>
        </div>

        {/* Nội dung truyền vào */}
        <div className={`relative z-0 ${isVisible ? 'translate-x-0' : '-translate-x-full'}`}>{children}</div>
      </div>
    </div>
  );
};

export default MobileDrawer;
